<template>
  <i18n-t
    class="caption-bold flex items-center gap-050"
    keypath="highfrequencygame.spots.picked"
    scope="global"
    tag="strong"
  >
    <template #count>
      <Transition appear mode="out-in" name="bounce-sm">
        <span
          :key="numberOfSpots"
          class="flex items-center justify-center bg-secondary-secondary-bold rounded-s p-025 w-300 h-300"
        >
          {{ numberOfSpots }}
        </span>
      </Transition>
    </template>
  </i18n-t>
</template>

<script lang="ts" setup>
type Props = { numberOfSpots: number }

defineProps<Props>()
</script>
